// eslint-disable-next-line
import React from 'react';
import { Link } from 'react-router-dom';
import HelpNav from '../../../HelpNav';
import WizardNav from '../../../WizardNav';
import EndTest from './EndTest';
import GetStepDefinitions from './GetStepDefinitions';
import { CmsContent, FlowData, Room } from '../../../proctorStepsTypes';

interface CompletionProps {
  flowData: FlowData;
  room: Room;
  cmsContent: CmsContent;
  progressStepperMax: number;
  introStep: number;
  outerStep: number;
  stepDetails: Record<number, { heading: string; imgClass: string; imgDesc: string }>;
}

function Completion({
  flowData,
  room,
  cmsContent,
  progressStepperMax,
  introStep,
  outerStep,
  stepDetails,
}: CompletionProps) {
  const { stepNum } = flowData;

  const navigation = () => {
    const prevLink =
      stepNum === introStep
        ? `/rooms/get/${room.id}/flow/monitor/step/1`
        : `/rooms/get/${room.id}/flow/completion/step/${stepNum - 1}`;

    const nextLink = `/rooms/get/${room.id}/flow/completion/step/${stepNum + 1}`;

    return (
      <WizardNav
        prevButton={
          stepNum >= introStep ? (
            <Link className='cb-btn cb-btn-sm cb-btn-light' to={prevLink}>
              Back
            </Link>
          ) : null
        }
        nextButton={
          stepNum < outerStep ? (
            <Link className='cb-btn cb-btn-sm cb-btn-yellow ml-auto' data-automation='nav-nextStep-Link' to={nextLink}>
              Next Step
            </Link>
          ) : null
        }
      />
    );
  };

  return (
    <>
      {stepNum === outerStep ? (
        <EndTest room={room} cmsContent={cmsContent} outerStep={outerStep} />
      ) : (
        stepNum >= introStep && (
          <GetStepDefinitions
            stepNum={stepNum}
            cmsContent={cmsContent}
            stepDetails={stepDetails}
            room={room}
            progressStepperMax={progressStepperMax}
          />
        )
      )}
      <HelpNav />
      {navigation()}
    </>
  );
}

export default Completion;
